import Vue from 'vue'

//将路由配置文件里面的meta.title做为抬头
import Title from './partials/title/title.vue'
Vue.component('Title',Title)

//尾部的路由导航
import NavbarFooter from './partials/navbarFooter/navbar-footer.vue'
Vue.component('NavbarFooter',NavbarFooter)
 
//返回上一级路由
import GoBack from './partials/goBack/go-back.vue'
Vue.component('GoBack',GoBack)

//漂浮的入驻按钮
import SettledIn from './partials/settledIn/settled-in.vue'
Vue.component('SettledIn',SettledIn)

//地址选择组件
import Addre from './partials/addre/addre.vue'
Vue.component('Addre',Addre)

//省份城市选择组件
import cityPick from './partials/addre/city/city.vue'
Vue.component('cityPick',cityPick)

//微信分享
import Share from './partials/share/share.vue'
Vue.component('Share',Share)

//调用地图
import mapApp from './partials/map/mapApp.vue'
Vue.component('mapApp',mapApp)

//选择物流园
import pickLogistics from './partials/addre/pickLogistics.vue'
Vue.component('pickLogistics',pickLogistics)

//通用选择组件
import commonPick from './partials/commonPick/commonPick.vue'
Vue.component('commonPick',commonPick)